export default __webpack_public_path__ + "static/media/headerImg2.c59f9cdc.webp";